import resume from "../assets/pdf/resume.pdf";
import akshayImg from "../assets/png/akshay.png";

export const headerData = {
  name: "Akshay Gosavi",
  title: "Full Stack Web Developer",
  desciption:
    "Building high-performance web applications, digital automation engines, and scalable REST APIs with Ruby on Rails, React.js, and Node.js.",
  image: akshayImg,
  resumePdf: resume,
};
